import React from 'react';
import PropTypes from 'prop-types';
import parse from "html-react-parser";
import _ from 'lodash';

function BulletPointList({ listItems }) {
    return <ul className="form-field__plain-list filled">
        {listItems.map((listItem) => {
            return <li key={_.uniqueId()}>{parse(listItem)}</li>;
        })}
    </ul>;
}

BulletPointList.propTypes = {
    listItems: PropTypes.array.isRequired
};

export default BulletPointList;
